/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step1_Provider_LockedInputs */



/**
* | output |
* | --- |
* | "Provider cannot be changed after authentication" |
*
* @param {Spaces_Wizard_Step1_Provider_LockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step1_provider_locked = /** @type {((inputs?: Spaces_Wizard_Step1_Provider_LockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step1_Provider_LockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anbieter kann nach der Authentifizierung nicht mehr geändert werden")
	return /** @type {LocalizedString} */ ("Provider cannot be changed after authentication")
});